import { render, staticRenderFns } from "./shelter-dashboard.vue?vue&type=template&id=0c452dbc&scoped=true&"
import script from "./shelter-dashboard.vue?vue&type=script&lang=js&"
export * from "./shelter-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./shelter-dashboard.vue?vue&type=style&index=0&id=0c452dbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c452dbc",
  null
  
)

export default component.exports